(function(){
  var EMBLEMS=[
    '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><path d="M50 12v76"/><circle cx="50" cy="10" r="4" fill="currentColor" stroke="none"/><path d="M32 28h36"/><rect x="35" y="30" width="30" height="30"/><path d="M35 44h30"/><path d="M40 60l3 7M50 60v7M60 60l-3 7"/></svg>',
    '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><circle cx="50" cy="24" r="4" fill="currentColor" stroke="none"/><path d="M50 30v34"/><path d="M50 38C34 28 20 32 9 44c15-3 24 1 33 8"/><path d="M50 38c16-10 30-6 41 6-15-3-24 1-33 8"/><path d="M44 64l6 12 6-12"/></svg>',
    '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><path d="M50 90C26 80 22 46 36 22"/><path d="M50 90c24-10 28-44 14-68"/><path d="M34 40c-6 0-11-3-13-9M32 56c-6 0-11-3-13-9M33 70c-6 1-11-2-14-8"/><path d="M66 40c6 0 11-3 13-9M68 56c6 0 11-3 13-9M67 70c6 1 11-2 14-8"/></svg>'
  ];
  function init(){
    var logo=document.querySelector('header-component .header-logo');
    if(!logo||!logo.parentElement)return;
    var box=document.createElement('div');box.className='vex-emblem';box.setAttribute('aria-hidden','true');
    logo.parentElement.appendChild(box);
    var cur=-1;
    var root=document.documentElement;
    function update(){
      var y=window.pageYOffset||document.documentElement.scrollTop||0;
      var threshold=300;
      if(y<threshold){root.classList.remove('vex-emblem-on');return;}
      root.classList.add('vex-emblem-on');
      var idx=Math.floor((y-threshold)/1100)%EMBLEMS.length;
      if(idx!==cur){cur=idx;box.innerHTML=EMBLEMS[idx];}
    }
    update();
    window.addEventListener('scroll',update,{passive:true});
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();